import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { getAllServices, deleteService } from '../../services/serviceService';
import { Service } from '../../types/service';

import LoadingSpinner from '../../components/common/LoadingSpinner';
import ErrorAlert from '../../components/common/ErrorAlert';
import ServiceFormModal from '../../components/admin/ServiceFormModal'; // سنقوم بإنشائه
import pageStyles from '../Page.module.css';

const ServicesManagementPage: React.FC = () => {
  const queryClient = useQueryClient();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingService, setEditingService] = useState<Service | null>(null);

  const { data: services, isLoading, isError, error } = useQuery<Service[], Error>({
    queryKey: ['services'],
    queryFn: getAllServices,
  });

  const deleteMutation = useMutation({
    mutationFn: deleteService,
    onSuccess: () => {
      toast.success('تم حذف الخدمة بنجاح!');
      queryClient.invalidateQueries({ queryKey: ['services'] });
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'فشل حذف الخدمة.');
    },
  });

  const handleOpenModal = (service: Service | null = null) => {
    setEditingService(service);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingService(null);
  };

  const handleDelete = (id: number) => {
    if (window.confirm('هل أنت متأكد من أنك تريد حذف هذه الخدمة؟')) {
      deleteMutation.mutate(id);
    }
  };

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorAlert message={error.message} />;

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1 className={pageStyles.pageTitle}>إدارة الخدمات</h1>
        <button onClick={() => handleOpenModal()} className="button primary">
          إضافة خدمة جديدة
        </button>
      </div>

      <div className={pageStyles.tableContainer}>
        <table>
          <thead>
            <tr>
              <th>اسم الخدمة</th>
              <th>الوصف</th>
              <th>الرسوم</th>
              <th>موجهة لـ</th>
              <th>إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {services?.map((service) => (
              <tr key={service.id}>
                <td>{service.name}</td>
                <td>{service.description}</td>
                <td>{service.fee}</td>
                <td>{service.type}</td>
                <td>
                  <button onClick={() => handleOpenModal(service)} className="button-sm">تعديل</button>
                  <button onClick={() => handleDelete(service.id)} className="button-sm danger" disabled={deleteMutation.isPending}>حذف</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <ServiceFormModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          service={editingService}
        />
      )}
    </div>
  );
};

export default ServicesManagementPage;
